import { useQuery } from '@tanstack/react-query'

import { getExternalMcpControl } from '../../api/assistant-api'

const externalMcpControlKey = ['mcp-control']

export function useExternalMcpControl() {
  return useQuery({
    queryKey: externalMcpControlKey,
    queryFn: getExternalMcpControl,
  })
}
